import FileSaver from 'file-saver';

export default (filename: string, filetype: string, content: string): void => {
  FileSaver.saveAs(new Blob([content], { type: `text/${filetype};charset=utf-8` }), filename);
};
